module.exports = __webpack_public_path__ + "img/69AA1A.489bc5c6.svg";